import { FC } from 'react';

import CustomLoading from 'modules/_shared/components/CustomLoading';

import sizes from 'constants/sizes';
import PublishIncentiveOfferModalHeader from './components/PublishIncentiveOfferModalHeader';
import PublishIncentiveOfferModalBody from './components/PublishIncentiveOfferModalBody';
import PublishIncentiveOfferModalFooter from './components/PublishIncentiveOfferModalFooter';
import PublishIncentiveOfferSuccessContent from './components/PublishIncentiveOfferSuccessContent';

import { usePublishIncentiveOfferModal } from './context/PublishIncentiveOfferModalContext';

const PublishIncentiveOfferModal: FC = () => {
  const { data } = usePublishIncentiveOfferModal();

  if (data.publishedOffer) {
    return (
      <>
        <PublishIncentiveOfferSuccessContent size={sizes.MD} />
      </>
    );
  }

  return (
    <>
      <PublishIncentiveOfferModalHeader />
      <PublishIncentiveOfferModalBody />
      <PublishIncentiveOfferModalFooter />

      {data.isLoading && <CustomLoading />}
    </>
  );
};

export default PublishIncentiveOfferModal;
